import { render, staticRenderFns } from "./PackageTableAdd.vue?vue&type=template&id=1f1ff7a6"
import script from "./PackageTableAdd.vue?vue&type=script&lang=js"
export * from "./PackageTableAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports